export const truncateText = function (text, len = 200) {
  if(text && (text.length > len)) {
    return text.substring(0, len).trim() + '...';
  }
  return text
}

export const getMaxOrderIndex = function (items) {
  let max = 0
  if (items) {
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      const index = item.orderIndex || 0
      if (index > max) {
        max = index
      }
    }
  }
  return max
}

export const getContactName = function(contact) {
  if (contact.type === 'person') {
    const tuple = []
    if (contact.firstName) {
      tuple.push(contact.firstName)
    }
    if (contact.lastName) {
      tuple.push(contact.lastName)
    }
    return tuple.join(' ')
  }
  return contact.companyName || contact.name
}

export const capitalize = function(text) {
  if (!text) {
    return text
  }
  if (text.length > 0) {
    return text[0].toUpperCase() + text.substring(1)
  }
  return text.toUpperCase();
}

export const sortByFilename = function (a, b) {
  let nameA = a.filename.toUpperCase(); // ignore upper and lowercase
  let nameB = b.filename.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
};

export const getRandomId = function() {
  const min = Math.ceil(10000);
  const max = Math.floor(100000);
  return `${new Date().getTime()}${Math.floor(Math.random() * (max - min) + min)}`
}
//  ISO 3166-1 alpha 2
export const countries = [
  {value: 'SE', title: 'Sverige'},
  {value: 'NO', title: 'Norge'},
  {value: 'DK', title: 'Danmark'},
  {value: 'FI', title: 'Finland'},
  {value: 'AX', title: 'Åland'},
  {value: 'EE', title: 'Estland'},
  {value: 'LV', title: 'Lettland'},
  {value: 'LT', title: 'Litauen'},
  {value: 'PL', title: 'Polen'},
  {value: 'DE', title: 'Tyskland'},
  {value: 'NL', title: 'Nederländerna'},
  {value: 'BE', title: 'Belgien'},
  {value: 'FR', title: 'Frankrike'},
  {value: 'ES', title: 'Spanien'},
  {value: 'GB', title: 'Storbritannien'},
  {value: 'IE', title: 'Irland'},
  {value: 'US', title: 'USA'},
  {value: 'CA', title: 'Kanada'},
]

export const paymentTerms= [
  { value: 10, text: '10 dagar'},
  { value: 15, text: '15 dagar'},
  { value: 20, text: '20 dagar'},
  { value: 30, text: '30 dagar'},
  { value: 45, text: '45 dagar'},
  { value: 60, text: '60 dagar'},
  { value: 90, text: '90 dagar'},
  { value: 120, text: '120 dagar'},
  { value: 180, text: '180 dagar'},
  { value: 365, text: '365 dagar'},
]
